import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { StudentSummaryService } from '../../../student-summary.service';
import { UserService } from '../../../../../shared-components/user/user.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { CardAssignment } from './card-assignment';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { AssignmentsCardModalComponent } from './assignments-card-modal/assignments-card-modal.component';
import { Card } from '../../../card-container/card/card';
import { interval } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-assignments-card',
    templateUrl: './assignments-card.component.html',
    styleUrls: ['./assignments-card.component.css']
})

export class AssignmentsCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    missingCount = 0;
    dueTodayCount = 0;
    dueTomorrowCount = 0;
    assignments: CardAssignment[] = [];
    displayedColumns: string[] = ['Due', 'Class', 'Assignment'];

    constructor(private dialog: MatDialog, private router: Router, private studentService: StudentService, private studentSummaryService: StudentSummaryService, private userService: UserService, private yearService: YearService) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getAssignments();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    checkIfMissing(assignment: CardAssignment) {
        // If missing return the isMissing class
        if (assignment.IsMissing) {
            return 'isMissing';
        }
    }

    viewAllClick() {
        this.router.navigate(['/student360/assignments']);
    }

    getAssignments() {
        this.assignments = [];
        this.missingCount = 0;
        this.dueTomorrowCount = 0;
        this.dueTodayCount = 0;
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardAssignments(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe(response => {
            response.body.forEach((a) => {
                this.assignments.push(a);
            });
            // Check if the assignment is missing
            this.assignments.forEach((a) => {
                if (a.IsMissing) {
                    // Swap the Due with DueDate and format
                    a.Due = moment(a.DueDate).format('MM/DD/YY').toString();
                }
            });
            // Get the assignment Counts
            if (this.assignments.length > 0) {
                this.missingCount = this.assignments[0].MissingCount;
                this.dueTodayCount = this.assignments[0].DueTodayCount;
                this.dueTomorrowCount = this.assignments[0].DueTomorrowCount;
            }
        });
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    cardClick() {
        if (!this.card.disabled) {
            this.dialog.open(AssignmentsCardModalComponent, {
                minWidth: '45vw',
                data: { assignments: this.assignments },
                disableClose: true,
                autoFocus: false
            });
        }
    }

}
